import { success } from '@react/react-spectrum/Toast';
import React from 'react';

const handleClick = (text) => {
  navigator.clipboard.writeText(text);
  success('Copied to clipboard', {
    timeout: 3000,
    closable: false,
  });
};

const CopyButton = ({ text, isDisabled = false, children }) => {
  return (
    <div
      onClick={() => {
        if (!isDisabled) {
          handleClick(text);
        }
      }}
    >
      {children}
    </div>
  );
};

export default CopyButton;
